// extracted by mini-css-extract-plugin
export default {"controls":"AddReservationForm_controls__tV5KS","action":"AddReservationForm_action__0VRpz","button-24":"AddReservationForm_button-24__PIkbT"};